// data/ForEveryone.js
const everyOneCardData = [
  {
    title: "Teams",
    description:
      "Streamline team profile management, present a consistent digital profile everywhere, and seamlessly manage offline leads for improved collaboration and efficiency.",
    image: "/EveryOneCards/teams.png",
  },
  {
    title: "Professional",
    description:
      "Your network is your net worth—grow your professional connections smartly and effortlessly with TapOnn, making valuable connections wherever you go.",
    image: "/EveryOneCards/TAPPON.png",
  },
  {
    title: "Businesses",
    description:
      "TapOnn is your all-in-one solution to acquire more reviews, boost your social presence, and effortlessly connect with customers, driving growth and success.",
    image: "/EveryOneCards/Tappon_stand.png",
  },
];

export default everyOneCardData; // ✅ must be default export
